// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","SubscribedPhotoblogs":"sq_a bhb_b bhb_bj","SubscribedPhotoblogs__link":"sq_b bhb_a bhb_r"};